import React from "react";
import Icon from "@ant-design/icons";
import Icons from "assets/icons";
import { ColumnsEdit } from "types/models/column-table-edit";

export type DataTableMenu = {
  tenDichVu: string;
  giaTri: number;
  soLan: number;
};

let dataTableMenu: Array<DataTableMenu> = [];

const optionsLieuDung: any = [
  {
    label: "1 lần/ngày",
    value: 0,
  },
  {
    label: "2 lần/ngày",
    value: 1,
  },
  {
    label: "1 lần/ngày",
    value: 2,
  },
  {
    label: "Chọn liều dùng",
    value: -1,
  },
];
const validatePositiveInteger = (_, value) => {
  if (!value || /^[0-9]\d*$/.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject(new Error('Chưa nhập đúng định dạng!'));
};

const columnsTableMenu: ColumnsEdit = [
  {
    title: "STT",
    key: "stt",
    align: "left",
    render: (v, r, i) => i + 1,
    width: '2%'
  },
  {
    title: "Mã dịch vụ",
    dataIndex: "maDichVu",
    key: "maDichVu",
    type: "INPUT",
    editable: true,
    width: "16%",
    align: "center"
  },
  {
    title: "Tên dịch vụ",
    dataIndex: "tenDichVu",
    key: 'tenDichVu',
    editable: true,
    type: "AUTO_COMPLETE",
  },
  {
    title: "Giá trị",
    dataIndex: 'giaTri',
    editable: true,
    type: "CURRENCY",
    width: "24%",
  },
  {
    title: "Số lần",
    dataIndex: 'soLan',
    editable: true,
    type: "INPUT",
    width: "12%",
  },
  {
    title: "",
    dataIndex: "",
    key: "action",
    width: '4%'
  },
];

export { columnsTableMenu, dataTableMenu, optionsLieuDung };
